import { OfferReferenceNumberField } from "@/services/backend/htz/offers/components/offer-reference-number-field";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import {
  PatchRequest,
  updateHtzOfferCache,
  useHtzOfferPatchMutation,
  useHtzOfferShowQuery,
} from "@/services/backend/htz/offers/api/offer-api";
import { Offer } from "@/services/backend/htz/offers/types/offer";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { DatePickerField } from "@/shared/components/field/date-picker-field";
import { EditorInputField } from "@/shared/components/field/editor-input-field";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CardSkeleton } from "@/shared/components/card-skeleton";

export function DataCard({ offerId }: { offerId: string }) {
  const { data, error, isLoading } = useHtzOfferShowQuery({ id: offerId });

  return (
    <div>
      {data && <Data data={data} />}
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
    </div>
  );
}

function Data({ data }: { data: Offer }) {
  const request: PatchRequest = { id: data.id };
  const [set] = useOptimisticDebouncedMutation(
    request,
    updateHtzOfferCache,
    useHtzOfferPatchMutation(),
  );
  const disabled = isImmutable(data);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Angebot")}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <OfferReferenceNumberField offerId={data.id} />
        <DatePickerField
          label={t("Angebotsdatum")}
          nullable={true}
          date={data.date ?? undefined}
          onDateChange={(date) =>
            set(
              { ...request, date: date ?? null },
              { ...data, date: date ?? null },
            )
          }
          fieldName="date"
          disabled={disabled}
        />
        <EditorInputField
          label={t("Besondere Vereinbarungen")}
          initialHtml={data.specialAgreements}
          onHtmlChange={(specialAgreements) =>
            set(
              { ...request, specialAgreements },
              { ...data, specialAgreements },
            )
          }
          fieldName="specialAgreements"
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
}
